import React from 'react';
import Spinner from 'react-spinner-material';
import { Doughnut } from 'react-chartjs-2';

const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
        display: false
    },
    cutoutPercentage: 60,
    tooltips: {
        backgroundColor: 'rgba(17, 24, 39, 0.9)',
        titleFontSize: 13,
        bodyFontSize: 12,
        xPadding: 12,
        yPadding: 10,
        cornerRadius: 8,
        displayColors: true,
        callbacks: {
            label: function (tooltipItem, data) {
                const dataset = data.datasets[tooltipItem.datasetIndex];
                const total = dataset.data.reduce((acc, val) => acc + val, 0);
                const value = dataset.data[tooltipItem.index];
                const percentage = ((value / total) * 100).toFixed(1);
                return ` ${data.labels[tooltipItem.index]}: ${value} (${percentage}%)`;
            }
        }
    }
};

// Color palette for inspection types
const colorPalette = [
    '#3B82F6', // Blue
    '#8B5CF6', // Purple
    '#EC4899', // Pink
    '#F97316', // Orange
    '#22C55E', // Green
    '#14B8A6', // Teal
    '#EAB308', // Yellow
    '#6366F1', // Indigo
    '#F43F5E', // Rose
    '#06B6D4', // Cyan
];

const hoverColorPalette = [
    '#2563EB',
    '#7C3AED',
    '#DB2777',
    '#EA580C',
    '#16A34A',
    '#0D9488',
    '#CA8A04',
    '#4F46E5',
    '#E11D48',
    '#0891B2',
];

export class InspectionTypeChart extends React.Component {
    render() {
        const { data: inspectionTypeData, language } = this.props;

        if (!inspectionTypeData) {
            return (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%'
                }}>
                    <Spinner size={50} spinnerColor="#2CA8FF" spinnerWidth={2} visible={true} />
                </div>
            );
        }

        if (inspectionTypeData.length === 0) {
            return (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    color: '#9CA3AF',
                    fontSize: '14px'
                }}>
                    Sem dados
                </div>
            );
        }

        const dataChart = {
            labels: inspectionTypeData.map(d => d.name || d.label || 'Desconhecido'),
            datasets: [{
                data: inspectionTypeData.map(d => d.qtt || d.value || 0),
                backgroundColor: inspectionTypeData.map((_, i) => colorPalette[i % colorPalette.length]),
                hoverBackgroundColor: inspectionTypeData.map((_, i) => hoverColorPalette[i % hoverColorPalette.length]),
                borderWidth: 0
            }]
        };

        const total = dataChart.datasets[0].data.reduce((acc, val) => acc + val, 0);

        return (
            <div style={{ position: 'relative', height: '100%', width: '100%' }}>
                <Doughnut data={dataChart} options={options} />
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    textAlign: 'center'
                }}>
                    <div style={{ fontSize: '1.5rem', fontWeight: 700, color: '#111827' }}>{total}</div>
                    <div style={{ fontSize: '0.75rem', color: '#6B7280' }}>Total</div>
                </div>
            </div>
        );
    }
}
